module.exports = __webpack_public_path__ + "static/media/eye.5913f472.svg";